// CDP-410 - Adding black color palette so that it can referenced as a colorScheme
const colors = {
  black: {
    50: '#000',
    100: '#000',
    200: '#000',
    300: '#000',
    400: '#000',
    500: '#000',
    600: '#000',
    700: '#000',
    800: '#000',
    900: '#000',
  },
};

export default colors;
